import Topbar from './Topbar.vue';

export default Topbar;
